/** 管理路由 */
import Layout from '@/views/layout/financeLayout'

const Router = {
	path: '/finance',
	component: Layout,
	redirect: '/finance/index',
	name: 'finance',
	hidden: true,
	meta: {
		requiresAuth: true,
		title: '财务汇总',
		index: 0,
		type: 'finance'
	},
	children: [
		{
			path: 'index', 
			component: () => import('@/views/finance/index'),
			meta: {
				requiresAuth: true,
				title: '已收款',
				icon: 'money',
				index: 1,
				type: 'finance',
				subType: 'index'
			}
		},
		{
			path: 'nofinance', 
			component: () => import('@/views/finance/nofinance'),
			meta: {
				requiresAuth: true,
				title: '应收款',
				icon: 'pay',
				index: 1,
				type: 'finance',
				subType: 'nofinance'
			}
		},
		{
			path: 'invoiceindex', 
			component: () => import('@/views/finance/invoice'),
			meta: {
				requiresAuth: true,
				title: '发票',
				index: 1,
				type: 'finance',
				subType: 'invoiceindex'
			}
		},
		// {
		// 	path: 'apply', 
		// 	component: () => import('@/views/finance/apply'),
		// 	meta: {
		// 		requiresAuth: true,
		// 		title: '案件费用申请',
		// 		index: 1,
		// 		type: 'finance',
		// 		subType: 'apply'
		// 	}
		// },
		{
			path: 'return', 
			component: () => import('@/views/finance/return'),
			meta: {
				requiresAuth: true,
				title: '案件退费',
				index: 1,
				type: 'finance',
				subType: 'return'
			}
		}
  ]
}

export default Router

export const managerRouterMenu = [
	...Router.children
]